import { SOCIALS } from 'shared/constants/socials';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

export const Header: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <a href="/ir-edu">
        <div className={styles['logo']} />
      </a>
      <div className={styles['socials']}>
        {SOCIALS.map(({ id, url }) => (
          <a target="_blank" href={url} key={id} className={clsx(styles['social'], styles[id])} rel="noreferrer" />
        ))}
      </div>
    </div>
  );
};
